import { ElementNotFound } from "@senciamatch/frontend/components/ElementNotFound";
import { FullScreenLoading } from "@senciamatch/frontend/components/FullScreenLoading";
import { trpc } from "@senciamatch/frontend/libs/trpc";
import type { EditBuildingInput } from "@senciamatch/shared/models/building";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";

export const BuildingEditPage: React.FC = () => {
  const { id } = useParams();
  const { register, handleSubmit, setValue } = useForm<EditBuildingInput>();
  const getBuilding = trpc.getBuilding.useQuery({ id: id as string });
  const updateBuilding = trpc.updateBuilding.useMutation();

  useEffect(() => {
    if (getBuilding.data?.building) {
      setValue("nameNayose", getBuilding.data.building.nameNayose);
      setValue("isSuitsNeeded", getBuilding.data.building.isSuitsNeeded);
      setValue("mustCleaning", getBuilding.data.building.mustCleaning);
      setValue("menOnly", getBuilding.data.building.menOnly);
      setValue("womenOnly", getBuilding.data.building.womenOnly);
      setValue("needDisasterCenter", getBuilding.data.building.needDisasterCenter);
    }
  }, [getBuilding.data, setValue]);

  if (getBuilding.isPending) return <FullScreenLoading />;
  if (!getBuilding.data?.building) return <ElementNotFound />;

  return (
    <div className="h-screen flex flex-col">
      <h2 className="text-2xl font-bold py-10 flex-shrink-0">物件編集</h2>
      <div className="flex-grow flex flex-col bg-white border border-base-100 px-8 max-w-[600px]">
        <div className="flex flex-col gap-8 mt-8 border-b border-gray-200 pb-8">
          <h2 className="text-lg font-bold mb-4">基本情報</h2>
          <div className="flex flex-col gap-2">
            <label htmlFor="nameNayose" className="text-sm text-gray-900 font-bold">
              物件名
            </label>
            <p className="text-sm text-gray-500">{getBuilding.data.building.name}</p>
          </div>

          <div className="flex flex-col gap-2">
            <label htmlFor="nameNayose" className="text-sm text-gray-900 font-bold">
              物件名カナ
            </label>
            <p className="text-sm text-gray-500">{getBuilding.data.building.name}</p>
          </div>

          <div className="flex flex-col gap-2">
            <label htmlFor="postalCode" className="text-sm text-gray-900 font-bold">
              住所
            </label>
            <p className="text-sm text-gray-500">
              {getBuilding.data.building.postalCode} <br />
              {getBuilding.data.building.address}
            </p>
          </div>
        </div>
        <form
          onSubmit={handleSubmit((data) => {
            if (!id) return;
            updateBuilding.mutate(
              { id: id || "", data },
              {
                onSuccess: () => {
                  getBuilding.refetch();
                  alert("更新しました");
                },
              },
            );
          })}
          className="flex flex-col gap-8 mt-8"
        >
          <div className="flex flex-col gap-2 flex-grow">
            <label htmlFor="lastName" className="text-sm text-gray-500">
              名寄せ
            </label>
            <input
              id="nameNayose"
              type="text"
              className="border border-gray-300 rounded-md p-2"
              {...register("nameNayose")}
            />
          </div>

          <div className="flex flex-col gap-2 flex-grow">
            <label htmlFor="isSuitsNeeded" className="text-sm text-gray-500">
              スーツ着用
            </label>
            <div className="flex items-center gap-2">
              <input
                id="isSuitsNeeded"
                type="checkbox"
                className="border border-gray-300 rounded-md p-2"
                {...register("isSuitsNeeded")}
              />
              <span className="text-sm text-gray-500">必要</span>
            </div>
          </div>

          <div className="flex flex-col gap-2">
            <label htmlFor="mustCleaning" className="text-sm text-gray-500">
              清掃
            </label>
            <div className="flex items-center gap-2">
              <input
                id="mustCleaning"
                type="checkbox"
                className="border border-gray-300 rounded-md p-2"
                {...register("mustCleaning")}
              />
              <span className="text-sm text-gray-500">必要</span>
            </div>
          </div>

          <div className="flex flex-col gap-2">
            <label htmlFor="menOnly" className="text-sm text-gray-500">
              男性専用
            </label>
            <div className="flex items-center gap-2">
              <input
                id="menOnly"
                type="checkbox"
                className="border border-gray-300 rounded-md p-2"
                {...register("menOnly")}
              />
              <span className="text-sm text-gray-500">専用</span>
            </div>
          </div>

          <div className="flex flex-col gap-2">
            <label htmlFor="womenOnly" className="text-sm text-gray-500">
              女性専用
            </label>
            <div className="flex items-center gap-2">
              <input
                id="womenOnly"
                type="checkbox"
                className="border border-gray-300 rounded-md p-2"
                {...register("womenOnly")}
              />
              <span className="text-sm text-gray-500">専用</span>
            </div>
          </div>

          <div className="flex flex-col gap-2">
            <label htmlFor="needDisasterCenter" className="text-sm text-gray-500">
              自衛消防技術認定・防災センター要員
            </label>
            <div className="flex items-center gap-2">
              <input
                id="needDisasterCenter"
                type="checkbox"
                className="border border-gray-300 rounded-md p-2"
                {...register("needDisasterCenter")}
              />
              <span className="text-sm text-gray-500">必要</span>
            </div>
          </div>

          <button type="submit" className="w-full bg-[#00AF31] text-white p-2 rounded-md">
            保存
          </button>
        </form>
      </div>
    </div>
  );
};
